<template>
    <base-dialog title="Alternate Kit Products" @close="close" :open="show">
        <template #default>
            <div class="document__content">														  
                <!-- <h4>Alternate Kit Products</h4> -->
                <p>The following items can be substituted for the selected part in this kit:</p>

                <div class="grid-container">
                    <div class="filter__container filter__container-modal-kits" v-for="(alt, index) in kit_alternatives" :key="index">
                        <label class="filter-list__item">
                            <span class="input-radio filter-list__input">
                                <span class="payment-methods__item-radio input-radio">
                                    <span class="input-radio__body">
                                        <input class="input-radio__input" :value="alt.item" name="checkout_payment_method" type="radio" v-model="selected_alt" />
                                        <span class="input-radio__circle"></span>
                                    </span>
                                </span>
                            </span>
                            <span class="filter-list__title">
                                <strong>{{alt.desc}}</strong><br />
                                Item: {{alt.item}}<br />
                                Manufacturer: {{alt.manufacturer}}<br />
                                <div class="cart-table__column--kit-size form-control-kit-size-modal" style="width: 100%">
                                    <select id="component-size" name="component-size" class="form-control form-control-select2 form-control-kit-size form-control-select2" tabindex="0" aria-hidden="false" v-if="alt.sizes.length > 0" @change="change_size($event.target.value, alt, index)" >
                                        <option v-for="(size, index) in alt.sizes" 
                                        :key="index"
                                        :value="size.QSIZEITM"
                                        :selected="size_sel == size.QSIZEITM">
                                            {{ (index == 0 ) ? 'Size' : size.QSIZEITM}}
                                        </option>
                                    </select>
                                </div>
                                On-Hand: {{alt.stockquantity}}<br />
                                Price: {{toUSD(alt.yourprice)}}
                            </span>
                        </label>
                    </div>
                </div>

            </div>
        </template>
        <template #actions>
            <div class="product__actions-item product__actions-item--addtocart">
                <button v-if="kit_alternatives != null && kit_alternatives.length > 0" class="btn btn-primary btn-lg btn-block product__actions-item--addtocart-kit-alt" @click="change_item">
                    Select Alternate Product
                </button>
                <button v-else class="btn btn-primary btn-lg btn-block product__actions-item--addtocart-kit-alt" @click="$emit('close')">Close</button>
            </div> 
        </template>
    </base-dialog>
</template>

<script>
import MXPrice from '../../../mixins/price';

export default {
    data() {
        return{
            selected_alt    : '',
            kit_item        : '',
            kit_itemdesc    : '',
            kit_alternatives: this.alternatives,
        }
    },
    props: {
        show: {
            type: Boolean
        },
        alternatives: {
            type: Array
        },
        sequence: {
            type: Number,
        },
        size_sel : {
            type: String
        }
    },
    computed: {
        // filterAlt() {
        //     const alts = this.alternatives.filter(a => a.KCSEQN == this.sequence);
        //     return alts;
        // }
    },
    mixins: [MXPrice],
    emits: ['close', 'select-alternative',],
    methods: {
        close() {
            // console.log('close');
            this.$emit('close');
        },

        change_size(val, alt, index){
            console.log('changed size');
            // console.log(alt);
            
            if(val){
                const kit_size = alt.sizes.find(s => s.QSIZEITM == val);
                // console.log(kit_size);
                // this.kit_item = kit_size.QITEMSZ;
                // this.kit_itemdesc = kit_size.IMDESC;
                alt.item = kit_size.QITEMSZ;
                // alt.desc = kit_size.IMDESC;
                alt.optOrigItem = kit_size.QITEMNUM;
                this.kit_alternatives[index] = alt;
            }else{
                alt.item = alt.optOrigItem;
                // alt.desc = alt.IMDESC;
                this.kit_alternatives[index] = alt;
            }
        },

        change_item(){

            if(this.selected_alt == ''){
                this.$emit('close');
                // alert('select one alternative option');
                return;
            }
            
            this.$emit('close');
            this.$emit('select-alternative', this.selected_alt, this.alternatives);
        }
    },
    updated(){
        this.kit_alternatives = [];
        this.selected_alt = '';
        // console.log(this.kit_alternatives);
        // console.log(this.alternatives);
        // console.log('size_sel = ' + this.size_sel);
        // console.table(this.alternatives);
        if(this.size_sel != ''){
            this.alternatives.forEach(alt => {
                const alt_size = alt.sizes.find(s => s.QSIZEITM == this.size_sel);
                if(alt_size != undefined){
                    this.kit_alternatives.push(alt);

                    alt.item = alt_size.QITEMSZ;
                    alt.optOrigItem = alt_size.QITEMNUM;
                }
            });
        }else{
            this.alternatives.forEach(alt => {
                alt.sizes.forEach(s => {
                    if(s.optOrigItem != ''){
                        alt.item = s.QITEMNUM;
                        alt.optOrigItem = s.QITEMNUM;
                    }
                });
                this.kit_alternatives.push(alt);
            });
        
            this.kit_alternatives = this.alternatives;
        }
        
    },
    created(){
        // console.log(this.kit_alternati   ves);
    }
}
</script>

<style scoped>
    dialog{
        padding: 7px !important;
    }

    .product__actions-item--addtocart-kit-alt{
        max-width: 100%;
    }
</style>